var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.taskInfo.length > 0)?_c('div',{staticClass:"task"},[_c('div',{staticClass:"task-title"},[_vm._v("任务列表")]),_c('div',{staticClass:"task-line"}),_vm._l((_vm.taskInfo),function(item){return _c('OneTask',_vm._b({key:item.id,attrs:{"taskInfo":item}},'OneTask',_vm.$attrs,false))})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }